<nb-card class="plan-upgrade-dialog">
  <nb-card-header>
    <h4>
      {{ "dialogs.planUpgrade.title" | translate : { plan: (targetName | translate) } }}
    </h4>
  </nb-card-header>

  <nb-card-body>
    <p class="intro">{{ "dialogs.planUpgrade.intro" | translate }}</p>

    @if (currentName) {
    <p class="legacy-note">
      <nb-icon icon="info-outline"></nb-icon>
      <span>
        {{
          "dialogs.planUpgrade.legacyNote"
            | translate
              : {
                  current: (currentName | translate),
                  target: (targetName | translate)
                }
        }}
      </span>
    </p>
    }

    <section class="conditions-block">
      <h5>{{ "dialogs.planUpgrade.conditions" | translate }}</h5>
      <dl class="conditions">
        <dt>{{ "dialogs.planUpgrade.newPlan" | translate }}</dt>
        <dd>
          {{ targetName | translate }} ·
          {{ (preview.recurring_net || 0) / 100 | currency : preview.currency }}
          {{ intervalKey | translate }}
          @if (!vatFree) {
          <span class="muted">{{ "dialogs.planUpgrade.plusVat" | translate }}</span>
          }
        </dd>

        @if (vatFree) {
        <dt>{{ "dialogs.planUpgrade.vatLabel" | translate }}</dt>
        <dd>{{ "dialogs.planUpgrade.vatFree." + preview.tax_treatment | translate }}</dd>
        } @else {
        <dt>
          {{ "dialogs.planUpgrade.vat" | translate : { percent: preview.tax_percent | number } }}
        </dt>
        <dd>{{ (preview.recurring_tax || 0) / 100 | currency : preview.currency }}</dd>
        }

        <dt class="strong">{{ "dialogs.planUpgrade.recurringGross" | translate }}</dt>
        <dd class="strong">
          {{ (preview.recurring_gross || 0) / 100 | currency : preview.currency }}
          {{ intervalKey | translate }}
        </dd>

        <dt class="strong">{{ "dialogs.planUpgrade.dueNow" | translate }}</dt>
        <dd class="strong">
          {{ (preview.due_now || 0) / 100 | currency : preview.currency }}
          <span class="muted">{{
            (vatFree ? "dialogs.planUpgrade.dueNowNoteNoVat" : "dialogs.planUpgrade.dueNowNote") | translate
          }}</span>
        </dd>

        @if (nextBillingDate) {
        <dt>{{ "dialogs.planUpgrade.nextBilling" | translate }}</dt>
        <dd>{{ nextBillingDate | date : "dd.MM.yyyy" }}</dd>
        }

        @if (preview.payment_method; as pm) {
        <dt>{{ "pages.organisation.paymentMethod.label" | translate }}</dt>
        <dd>
          @if (pm.type === "card") {
          {{ pm.brand || "" | titlecase }} •••• {{ pm.last4 }}
          } @else if (pm.type === "sepa_debit") {
          {{ "pages.organisation.paymentMethod.sepa" | translate }} •••• {{ pm.last4 }}
          } @else {
          {{ pm.type }} {{ pm.last4 ? "•••• " + pm.last4 : "" }}
          }
        </dd>
        }
      </dl>
    </section>

    <ul class="notes">
      <li>{{ "dialogs.planUpgrade.noteImmediate" | translate }}</li>
      <li>{{ "dialogs.planUpgrade.noteContinues" | translate }}</li>
    </ul>

    <nb-checkbox
      class="accept"
      [class.accept--missing]="acceptMissing && !accepted"
      [(ngModel)]="accepted"
      [ngModelOptions]="{ standalone: true }"
    >
      {{ "dialogs.planUpgrade.accept" | translate }}
    </nb-checkbox>
    @if (acceptMissing && !accepted) {
    <p class="error">{{ "dialogs.planUpgrade.acceptMissing" | translate }}</p>
    }
    @if (errorKey) {
    <p class="error">{{ errorKey | translate }}</p>
    }
    @if (paymentFailed) {
    <button
      nbButton
      outline
      status="primary"
      size="small"
      type="button"
      class="fix-payment"
      [nbSpinner]="openingPortal"
      [disabled]="openingPortal"
      (click)="openPaymentDetails()"
    >
      <span>{{ "dialogs.planUpgrade.updatePayment" | translate }}</span>
      <nb-icon icon="external-link-outline"></nb-icon>
    </button>
    }
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="basic"
      type="button"
      [disabled]="submitting"
      (click)="dialogRef.close(false)"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      type="button"
      [nbSpinner]="submitting"
      [disabled]="submitting"
      (click)="confirm()"
    >
      {{ "dialogs.planUpgrade.confirm" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
